import React from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { LIGHT_GRAY } from '../../common/colors';

// Monthly/Annual toggle above the tier cards. `subLabel` only shows when
// annual is selected (03a §3.1: "Annual plans are billed once for twelve
// months. You pay for ten.").
const BillingToggle = ({ monthlyLabel, annualLabel, subLabel, value, onChange }) => (
  <Box sx={{ textAlign: 'center', mb: 5 }}>
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, next) => next && onChange(next)}
      sx={{
        backgroundColor: 'background.paper',
        border: `1px solid ${LIGHT_GRAY}`,
        borderRadius: '999px',
        p: 0.5,
        // Selected colours live on the button rule itself, not a separate
        // `& .Mui-selected` block: MUI's own selected style is emitted in a
        // cascade layer, where an !important declaration from an earlier
        // layer wins, so the looser selector lost and the pill rendered
        // MUI-grey instead of brand purple.
        '& .MuiToggleButton-root': {
          border: 0,
          borderRadius: '999px !important',
          textTransform: 'none',
          fontWeight: 600,
          px: 3,
          color: 'surface.contrastText',
          '&.Mui-selected': {
            backgroundColor: 'primary.main',
            color: 'common.white',
            '&:hover': { backgroundColor: 'primary.main' },
          },
        },
      }}>
      <ToggleButton value="monthly">{monthlyLabel}</ToggleButton>
      <ToggleButton value="annual">{annualLabel}</ToggleButton>
    </ToggleButtonGroup>
    {value === 'annual' && subLabel && (
      <Typography variant="body2" sx={{ color: 'surface.contrastText', mt: 1.5 }}>
        {subLabel}
      </Typography>
    )}
  </Box>
);

export default BillingToggle;
